import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

// Importar dependencias
import VueAnalytics from "vue-analytics";
import VueMixpanel from "vue-mixpanel";
import VueDeviceDetector from "vue-device-detector";

// Configurar dependencias
Vue.use(VueMixpanel, {
  token: process.env.VUE_APP_MIXPANEL_TOKEN
});

// Configurar Google Analytics
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_ID,
  router
});

// Configurar Device Detector
Vue.use(VueDeviceDetector);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
